exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-404-error-page {\n  background: white;\n  padding: 16px;\n  color: black;\n  border-radius: 8px;\n}\n.app-404-error-page__title {\n  font-size: 160px;\n}\n.app-404-error-page__text {\n  font-size: 26px;\n}\n", ""]);

// exports
